import { useMemo } from 'react'

import { RoutesPath } from 'src/types'
import { useLocales } from 'src/contexts'

import { useNavigation } from 'src/hooks/useNavigation'
import { useManageServiceContacts } from 'src/hooks/useManageServiceContacts'
import { useGetColorThemeAndNext } from 'src/hooks/useGetColorThemeAndNext'
import { useIsMobile } from 'src/hooks/use-mobile'
import { serviceTypeDictionary } from 'src/helpers/serviceTypeDictionaryForContacts'

export const useFavoritesContacts = () => {
  const { translations } = useLocales()
  const { mainThemeColor } = useGetColorThemeAndNext()
  const { navigateTo } = useNavigation()
  const { allServiceContacts, isLoadingGetContacts } =
    useManageServiceContacts()
  const isMobile = useIsMobile()
  const hiddenOnMobile = isMobile ? 'hidden' : ''

  const favoriteContacts = useMemo(() => {
    return allServiceContacts?.filter(contact => contact.isFavorite)
  }, [allServiceContacts])

  const handleCall = (phoneNumber: string): void => {
    window.location.href = `tel:${phoneNumber}`
  }

  const handleNavigateToContacts = (): void => {
    navigateTo(RoutesPath.SERVICE_CONTACTS_HISTORY)
  }

  return {
    favoriteContacts,
    isLoadingGetContacts,
    handleCall,
    locale: translations.homePage.favoriteContacts,
    favoriteContactsCount: favoriteContacts?.length || 0,
    navigateTo,
    handleNavigateToContacts,
    serviceTypeDictionary: serviceTypeDictionary(translations.serviceContacts),
    mainThemeColor,
    hiddenOnMobile,
  }
}
